import { create } from "zustand";
import { persist } from "zustand/middleware";

interface DemoModeState {
  enabled: boolean;
  setEnabled: (enabled: boolean) => void;
  toggleEnabled: () => void;
}

export const useDemoModeStore = create<DemoModeState>()(
  persist(
    (set) => ({
      enabled: false,
      setEnabled: (enabled: boolean) => set({ enabled }),
      toggleEnabled: () => set((state) => ({ enabled: !state.enabled })),
    }),
    {
      name: "demo-mode-storage",
    },
  ),
);
